export class ScreensState {
  constructor(
    public isAnyPending = false,
    public isAnyUploading = false,
    public isAllPlaying = false,
    public isAllWaiting = false,
    public isBusy = false
  ) {}
}
